var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CompanyDetail',{class:['col-company', {'large':!_vm.$store.state.ui.sourcing.colonnes.includes('variables') && !_vm.$store.state.ui.sourcing.colonnes.includes('dechets')}],attrs:{"company":_vm.entreprise}})
}
var staticRenderFns = []

export { render, staticRenderFns }